import _ from 'lodash';
import { EditState, IReportingUser } from '../models';

const initializeNewUser = (surveyId: number, id?: number): IReportingUser => {
	return {
		id: id || 0,
		surveyId,
		firstName: '',
		lastName: '',
		emailAddress: '',
		isCreator: false,
		editState: EditState.Add,
		hasSentEmail: false,
	};
};

export const ReportingHelper = {
	initializeNewUser,
};
